/**
 * Run callback during browser idle time if supported,
 * otherwise fallback to setTimeout with 100ms delay.
 *
 * @param callback - Function to execute
 */
export function runWhenIdle(callback: () => void) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback);
  } else {
    setTimeout(callback, 100);
  }
}
